/**
 * Detect user's locale based on the browser's navigator.languages
 *
 * @param {object} options
 * @returns {string|null}
 */
// @see https://phrase.com/blog/posts/ultimate-guide-to-vue-localization-with-vue-i18n/
export function getBrowserLocale(options = {}): string | null {
  const defaultOptions = { countryCodeOnly: false }
  const opt = { ...defaultOptions, ...options }
  const navigatorLocale = navigator.languages !== undefined
    ? navigator.languages[0]
    : navigator.language

  if (!navigatorLocale) {
    return null
  }

  return opt.countryCodeOnly
    ? navigatorLocale.trim().split(/-|_/)[0]
    : navigatorLocale.trim()
}

/**
 * Get starting locale or default
 *
 * @returns {string}
 */
export function getStartingLocale() {
  const browserLocale = getBrowserLocale({ countryCodeOnly: true }) || ''
  if (['en', 'ja'].includes(browserLocale)) {
    return browserLocale
  }
  return process.env.VUE_APP_I18N_LOCALE || 'en'
}
